module.exports = __webpack_public_path__ + "static/media/S1_00025.fe19411b.jpg";